import SearchFilter from './ui/filters/SearchFilter';
import PrimaryButton from './ui/PrimaryButton';
import { PlusOutlined } from '@ant-design/icons';
import { useDrawerStore } from '../store';
import React from 'react';

interface HeaderFilterProps {
  showCreate?: boolean;
  showSearch?: boolean;
  /** Extra filter controls, shown next to the search box. */
  extra?: React.ReactNode;
}
const HeaderFilter: React.FC<HeaderFilterProps> = ({
  showCreate = true,
  showSearch = true,
  extra,
}) => {
  const drawerStore = useDrawerStore();
  return (
    <>
      <div className={'flex p-4 justify-between'}>
        <div className={'flex items-center gap-3'}>
          {showSearch && <SearchFilter />}
          {extra}
        </div>
        {showCreate && (
          <PrimaryButton
            icon={<PlusOutlined />}
            onClick={drawerStore.onClose}
            label={'Create'}
          />
        )}
      </div>
    </>
  );
};

export default HeaderFilter;
